import { deviceChange, isDesktopQuery, isTabletQuery, getFeatureEnabled, formatCurrency, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { BALANCE_UPDATED, Feature, BALANCE_QUERY } from '@gig/magic-messages';
import '@gig/magic-sdk/dist/adapter/users/signup';

/**
 * The balance component shows the current
 * balance however when updates occur it will delay
 * the update by the specified amount of time.
 *
 * Useful for in-gameplay balance changes to avoid
 * showing users winnings instantly.
 *
 * This component differs from the `magic-balance` component (for Core) because
 * the currency needs to be specified explicitly.
 */
var CurrencyBalance = /** @class */ (function (_super) {
    __extends(CurrencyBalance, _super);
    function CurrencyBalance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The actual displayed balance.
         */
        _this.balance = null;
        /*
         * Whether or not the balance is currently being
         * delayed to avoid showing changes before the game
         * has finished its spin.
         */
        _this.balanceLoading = false;
        _this.isDesktop = false;
        _this.isTablet = false;
        _this.isTopNavigationEnabled = true;
        _this.delayTimeout = null;
        _this.balanceSubscription = null;
        _this.currencySubscription = null;
        _this.deviceSubscription = null;
        return _this;
    }
    CurrencyBalance.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, getFeatureEnabled(Feature.TOP_NAVIGATION)];
                    case 1:
                        _a.isTopNavigationEnabled = _b.sent();
                        this.deviceSubscription = deviceChange(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _a = this;
                                        return [4 /*yield*/, isTabletQuery()];
                                    case 1:
                                        _a.isTablet = _c.sent();
                                        _b = this;
                                        return [4 /*yield*/, isDesktopQuery()];
                                    case 2:
                                        _b.isDesktop = _c.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
                            var currentBalance;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.queryBalance()];
                                    case 1:
                                        currentBalance = _a.sent();
                                        this.clearTimer();
                                        if (this.balance &&
                                            currentBalance &&
                                            currentBalance.balance !== this.balance.balance) {
                                            this.balanceLoading = true;
                                            this.delayTimeout = setTimeout(function () {
                                                _this.balanceLoading = false;
                                                _this.balance = currentBalance;
                                            }, this.delay);
                                            return [2 /*return*/];
                                        }
                                        this.balance = currentBalance !== null && currentBalance !== void 0 ? currentBalance : null;
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    CurrencyBalance.prototype.destroyed = function () {
        var _a, _b;
        this.clearTimer();
        if (this.balanceSubscription) {
            this.balanceSubscription.unsubscribe();
        }
        (_a = this.currencySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.deviceSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    };
    CurrencyBalance.prototype.delayChanged = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.delay === 0)) return [3 /*break*/, 2];
                        _b = this;
                        return [4 /*yield*/, this.queryBalance()];
                    case 1:
                        _b.balance = (_a = (_c.sent())) !== null && _a !== void 0 ? _a : null;
                        this.balanceLoading = false;
                        _c.label = 2;
                    case 2:
                        this.clearTimer();
                        return [2 /*return*/];
                }
            });
        });
    };
    CurrencyBalance.prototype.hasExtraItem = function () {
        return this.$slots['extra-item'];
    };
    CurrencyBalance.prototype.clearTimer = function () {
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
            this.delayTimeout = null;
        }
        this.balanceLoading = false;
    };
    CurrencyBalance.prototype.queryBalance = function () {
        return window.queryBus.query(BALANCE_QUERY, this.currency);
    };
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], CurrencyBalance.prototype, "delay", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], CurrencyBalance.prototype, "currency", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CurrencyBalance.prototype, "compact", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CurrencyBalance.prototype, "gameplay", void 0);
    __decorate([
        Watch('delay'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CurrencyBalance.prototype, "delayChanged", null);
    CurrencyBalance = __decorate([
        Component({
            name: 'corex-currency-balance',
            filters: {
                formatCurrency: formatCurrency,
            },
        })
    ], CurrencyBalance);
    return CurrencyBalance;
}(Mixins(MagicConfigMixin)));

export default CurrencyBalance;
